import { render, staticRenderFns } from "./VehicleDetailsAppDialog.vue?vue&type=template&id=201fe6f1"
import script from "./VehicleDetailsAppDialog.vue?vue&type=script&lang=js"
export * from "./VehicleDetailsAppDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports